/**
 * SmoothScrolljs
 * File for smooth scroll effect in anchor links
 */

jQuery(document).ready(function($) {

    // Scroll functionality to elements with class "scroll"

    var $root = $('html, body');
    $('a.scroll').click(function () {
        var url = ($(this).attr('href'));
        if (url != '#' && url != '#/') {
            $root.animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 500);
        }
        return false;
    });

    // Scroll functionality to nav items

    $('#site-navigation a').click(function () {

        var url = ($(this).attr('href'));
        if (url != '#' && url != '#/') {
            var animateTop = $($.attr(this, 'href')).offset().top - 50;
            $root.animate({
                scrollTop: animateTop
            }, 500);

            var menuContainer    = $('.page-header');                         // Header
            var menuToggle       = menuContainer.find( '.menu-button' );      // Menu button
            var siteHeaderMenu   = menuContainer.find( '#site-header-menu' ); // Main navigation parent    
            
            siteHeaderMenu.fadeOut('normal', function() {
                siteHeaderMenu.removeClass('toggled-on').attr('aria-expanded', 'false');
            });        
            menuContainer.removeClass('toggled-on').attr('aria-expanded', 'false');
            menuToggle.removeClass('toggled-on').attr('aria-expanded', 'false');


        }

        return false;
    });

});